import { AbstractControl, FormGroup, ValidationErrors } from '@angular/forms';

interface RegistrationErrorBody {
  reason?: string;
  field?: string;
}

const DEFAULT_REGISTRATION_ERROR = 'Please verify your details and try again.';

export function applyRegistrationValidationError(form: FormGroup, error: unknown): string {
  const body = getRegistrationErrorBody(error);
  const reason = body.reason || DEFAULT_REGISTRATION_ERROR;
  const field = body.field;

  if (!field) {
    return reason;
  }

  const control = form.get(['tenantInfo', field]);
  if (!control) {
    return reason;
  }

  control.setErrors({
    ...(control.errors || {}),
    server: reason,
  });
  control.markAsTouched();

  return reason;
}

export function clearServerValidationError(control: AbstractControl | null): void {
  if (!control?.hasError('server')) {
    return;
  }

  const nextErrors = { ...(control.errors as ValidationErrors) };
  delete nextErrors['server'];
  control.setErrors(Object.keys(nextErrors).length > 0 ? nextErrors : null);
}

function getRegistrationErrorBody(error: unknown): RegistrationErrorBody {
  if (!error || typeof error !== 'object' || !('error' in error)) {
    return {};
  }

  const body = (error as { error?: RegistrationErrorBody }).error;
  if (!body || typeof body !== 'object') {
    return {};
  }

  return body;
}
